var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.fading ? _vm.value : true)?_c('div',{staticClass:"inherit-box skeletion-breath skeletion-box",class:[{ 'absolute-full': _vm.absolute },{ 'fade': _vm.fading }, { 'fade-out': _vm.fading && !_vm.value }, ("skeletion-" + (_vm.dark ? 'dark' : 'light'))]}):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-227ad877","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/skeletion/box.vue
// module id = null
// module chunks = 